import { type ReactNode, useMemo } from 'react';

import { api } from '@/api/query';
import { PageLoader } from '@/shared/ui';

import { UserContext, type UserContextState } from './user.context';
import { UserError } from './user-error.component';

export interface UserProviderProps {
  children: ReactNode;
}

export function UserProvider({ children }: UserProviderProps) {
  const { data, error, isError, isLoading } = api.auth.query.useGetUser();

  const value = useMemo<null | UserContextState>(
    () => (data?.user ? { user: data.user } : null),
    [data],
  );

  if (isLoading) {
    return <PageLoader />;
  }

  if (isError || !value) {
    return <UserError error={error} />;
  }

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}
